<template>
  <section v-on:click="sectionClicked">
    <Header :class="{scrolled: isScrolled}" ref="header"
      menu="teamUpForYouth"/>
    <div class="blog">
      <div class="blogHeader loading" v-if="loadingHeader"></div>
      <div class="blogHeader temUpYouth" v-else-if="headerData">
        <div class="cnt">
          <div class="theBlogHeader">
            <div class="blogInfo">
              <h2>Team Up<div class="br"></div><span>For Youth</span></h2>
              <p>{{headerData.profile}}</p>
            </div>
            <div class="videoCnt" v-if="1>2">
              <div class="theVideo">
                <div class="videoCover" v-on:click="playVideo" v-if="!videoPlaying">
                  <div class="playIcon"></div>
                </div>
                <VuePlyr ref="video" :options="{ hideControls: false }">
                  <video></video>
                </VuePlyr>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cnt">
        <div class="theBlog loadingData" v-if="loadingCategory">
          <div class="theBlogScCnt">
            <div class="theBlogSc">
              <div class="blogItem" v-for="i in 6" :key="i">
                <div class="itemIn"></div><button></button>
              </div>
            </div>
          </div>
        </div>
        <div class="theBlog notFound" v-else-if="!categories || categories.length < 1">
          <img src="../assets/folder-locked.png">
          <h4>Belum ada aksi bersama yang bisa diikuti</h4>
        </div>
        <div class="theBlog" v-else>
          <div class="theBlogScCnt">
            <div class="theBlogSc">
              <div class="blogItem category" v-for="(item, i) in categories" :key="i">
                <div class="itemIn" :style="{'background-color': item.color}"
                  v-on:click.stop="openCategory(item)">
                  <h4>{{item.name}}</h4>
                  <div class="blogThumb" v-if="item.thumb"
                    :style="{'background-image': `url(${item.thumb})`}">
                    <div class="playIcon" v-if="item.profileVideo"></div>
                  </div>
                  <div class="blogImg" v-if="item.media && 1>2"
                    :style="{'background-image':
                    `url(${item.media.imageMd.replace('://demoapi.', '://api.')})`}"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ProfileDialog ref="profileDialog"/>
    <SupportDialog ref="supportDialog"/>
  </section>
</template>

<script>
import VuePlyr from 'vue-plyr';
import 'vue-plyr/dist/vue-plyr.css';

import Header from '@/components/Header.vue';
import ProfileDialog from '@/components/ProfileDialog.vue';
import SupportDialog from '@/components/SupportDialog.vue';

export default {
  name: 'home',
  components: {
    Header,
    ProfileDialog,
    SupportDialog,
    VuePlyr,
  },
  data() {
    return {
      isScrolled: false,
      viewType: 'list',
      loadingHeader: true,
      headerData: null,
      videoPlaying: false,

      /**
       * Category
       *
       */
      loadingCategory: true,
      categories: [],
    };
  },
  created() {
    document.addEventListener('scroll', this.scrolled);
  },
  destroyed() {
    document.removeEventListener('scroll', this.scrolled);
  },
  computed: {},
  methods: {
    doNothing() {},
    sectionClicked() {
      if (this.$refs.header) this.$refs.header.sectionClicked();
    },
    openCategory(item) {
      this.$router.push(`/team-up-for-youth/category/${item.code}`);
    },
    scrolled() {
      this.isScrolled = window.scrollY > 30;
    },
    openProfile(item) {
      this.$refs.profileDialog.open(item);
      this.$http.get(this.$config.uri(`misc/profile/${item.id}/record/play`)).then((r) => {});
    },
    support(item) {
      this.$refs.supportDialog.open(item);
      this.$http.get(this.$config.uri(`misc/profile/${item.id}/record/view`)).then((r) => {});
    },
    playVideo() {
      const v = this.$refs.video.player;
      if (v) v.play();
      this.videoPlaying = true;
    },
    getHeader() {
      this.loadingHeader = true;
      this.$http.get(this.$config.uri('misc/profile/all?header=y')).then((r) => {
        this.headerData = (r.data.status === 200) ? r.data.data : null;
        this.loadingHeader = false;
        const m = (this.headerData && this.headerData.media) ? this.headerData.media : null;
        if (m) {
          const src = [];
          if (m.vid1080p) src.push({ src: m.vid1080p, type: 'video/mp4', size: 1080 });
          if (m.vid720p) src.push({ src: m.vid720p, type: 'video/mp4', size: 720 });
          if (m.vid480p) src.push({ src: m.vid480p, type: 'video/mp4', size: 480 });
          if (m.vid360p) src.push({ src: m.vid360p, type: 'video/mp4', size: 360 });
          setTimeout(() => {
            const v = this.$refs.video.player;
            v.source = { type: 'video', title: this.headerData.name, sources: src };
            // v.play();
          });
        }
      });
    },
    getCategories() {
      this.loadingCategory = true;
      this.$http.get(this.$config.uri('challenge/categories?youth=y')).then((r) => {
        this.loadingCategory = false;
        this.categories = (r.data.status === 200) ? r.data.data : [];
      });
    },

    /**
     * Analytic
     *
     */
    fireAlEvent(convId) {
      this.$emit('fireal', 'page_visit', 'teamup_youth', null, convId, (r) => {
        if (r.data.status !== 200) return;
        alTimer = setTimeout(() => {
          this.fireAlEvent(r.data.id);
        }, 5000);
      });
    },
  },
  beforeDestroy() {
    if (alTimer) clearTimeout(alTimer);
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.title = 'Team Up For Youth - Team Up For Impact';
    this.viewType = localStorage.getItem('viewType') || 'list';
    this.getHeader();
    this.getCategories();

    this.fireAlEvent();
  },
};
</script>

<style lang="scss">
.plyr__control--overlaid{
  background: #5351a4 !important;
}
.plyr--full-ui input[type=range]{
  color: #f14724 !important;
}
.blogHeader.temUpYouth{
  .videoCnt{
    .plyr{
      border-radius: 5px;
    }
  }
}
</style>

<style scoped lang="scss">
.blog{
  background-color: #fff;
}
.blogHeader{
  background-image: url(../assets/home-blur.jpg);
  background-size: cover;
  background-position: center;
  padding-top: 40px;
  &:before{
    content: "";
    position: absolute;
    left: 0; top: 0; right: 0; bottom: 0;
    background-color: #fff;
    opacity: .26;
    @media (max-width: 1480px) {
      opacity: .36;
    }
    @media (max-width: 1029px) {
      opacity: .46;
    }
    @media (max-width: 869px) {
      opacity: .56;
    }
  }
  .cnt{
    position: relative;
    z-index: 3;
  }
  &.loading{
    background-image: url(../assets/loading.svg);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 46px auto;
    height: 100vh;
  }
  .theBlogHeader{
    display: flex;
    align-items: center;
    justify-content: space-between;
    @media (max-width: 1080px) {
      display: block;
      text-align: center;
      padding: 0 40px;
    }
    @media (max-width: 680px) {
      padding: 0 10px;
    }
    .blogInfo{
      padding-top: 40px;
      width: calc(100% - 940px);

      /**
       * No Video
       *
       */
      padding: 140px 0 320px;
      margin: 0 auto;
      text-align: center;
      width: 100% !important;
      max-width: 960px;

      @media (max-width: 1480px) {
        width: calc(100% - 780px);
      }
      @media (max-width: 1200px) {
        width: calc(100% - 740px);
      }
      @media (max-width: 1180px) {
        width: calc(100% - 700px);
      }
      @media (max-width: 1080px) {
        width: auto;
        padding: 120px 0 20px;

        /**
         * No Video
         *
         */
        padding: 100px 0 280px;

      }
      @media (max-width: 680px) {
        padding: 96px 0 40px;

        /**
         * No Video
         *
         */
        padding: 60px 0 240px;
      }
      h2{
        color: #5351a4;
        margin: 0 0 20px;
        font-family: 'GolosUIWebBold', sans-serif;
        font-size: 80px;
        text-transform: uppercase;
        line-height: 1;
        span{
          color: #fdbb30;
        }
        .br{

          /**
           * No Video
           *
           */
          display: none;

          @media (max-width: 1080px) {
            // display: none;
          }
        }
        @media (max-width: 1480px) {
          font-size: 68px;
        }
        @media (max-width: 1180px) {
          font-size: 58px;
        }
        @media (max-width: 1080px) {
          max-width: 620px;
          margin: 0 auto 20px;
        }
        @media (max-width: 680px) {
          font-size: 50px;
          margin: 0 0 14px;
        }
      }
      p{
        margin: 0;
        color: #444;
        font-weight: 400;
        font-size: 22px;
        line-height: 1.3;
        @media (max-width: 1480px) {
          font-size: 20px;
        }
        @media (max-width: 1180px) {
          font-size: 18px;
        }
        @media (max-width: 1080px) {
          max-width: 620px;
          margin: 0 auto;
        }
        @media (max-width: 680px) {
          font-size: 16px;
        }
      }
    }
    .videoCnt{
      width: 860px;
      padding: 160px 0;
      @media (max-width: 1480px) {
        width: 740px;
      }
      @media (max-width: 1200px) {
        width: 680px;
      }
      @media (max-width: 1180px) {
        width: 640px;
      }
      @media (max-width: 1080px) {
        width: auto;
        padding: 40px 0 60px;
      }
      @media (max-width: 680px) {
        padding: 0 0 60px;
      }
      .theVideo{
        position: relative;
        .videoCover{
          position: absolute;
          left: 0; right: 0; bottom: 0; top: 0;
          background-image: url(../assets/team-up-for-youth-video-cover.jpg);
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          z-index: 3;
          border-radius: 5px;
          cursor: pointer;
          .playIcon{
            position: absolute;
            z-index: 3;
            width: 74px; height: 74px;
            left: 50%; top: 50%;
            margin: -36px 0 0 -36px;
            border-radius: 50%;
            background-color: #5351a4;
            background-color: rgba(0, 0, 0, .46);
            background-image: url(../assets/play.png);
            background-size: 34px auto;
            background-position: 22px 50%;
            background-repeat: no-repeat;
            transition: all .3s ease;
          }
          &:hover{
            .playIcon{
              background-color: #5351a4;
            }
          }
        }
      }
      iframe{
        display: block;
        width: 100%; height: auto;
        border: none;
      }
    }
  }
}

.theBlog{
  transition: all .3s ease;
  padding: 0 0 60px;

  /**
   * No video
   *
   */
  margin-top: -200px;
  position: relative;
  z-index: 8;

  @media (max-width: 1080px) {
    padding-left: 40px;
    padding-right: 40px;
  }
  @media (max-width: 680px) {
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 30px;
  }
  .theBlogScCnt{
    @media (max-width: 860px) {
      // width: 100%;
      // padding: 10px 0 0;
      // margin: 0 auto;
      // overflow-x: auto;
    }
  }
  .theBlogSc{
    display: flex;
    justify-content: center;
    transition: all .7s ease;
    flex-wrap: wrap;
    @media (max-width: 860px) {
      // width: 840px;
    }
    .blogItem{
      position: relative;
      transition: all .3s ease;
      width: 33.333333333%;
      @media (max-width: 768px) {
        width: 50%;
      }
      .itemIn{
        background-color: #eee;
        position: relative;
        width: 100%; height: 360px;
        box-sizing: border-box;
        color: #fff;
        cursor: pointer;
        transition: all .3s ease;
        @media (max-width: 1160px) {
          height: 26vw;
        }
        @media (max-width: 768px) {
          height: 40vw;
        }
        .timestamp{
          text-transform: uppercase;
          font-weight: bold;
          font-size: 14px;
          margin: 0 0 6px;
          display: none;
        }
        h4{
          margin: 0;
          line-height: 1.1;
          transition: all .3s ease;
          display: block;
          position: absolute;
          font-size: 26px;
          color: #fff;
          text-transform: uppercase;
          font-family: 'GolosUIWebBold', sans-serif;
          z-index: 991;
          font-weight: 600;
          top: 30px;
          left: 40px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          @media (max-width: 1480px) {
            font-size: 24px;
            top: 24px; left: 30px;
          }
          @media (max-width: 1160px) {
            font-size: 22px;
          }
          @media (max-width: 860px) {
            font-size: 20px;
            left: 20px; top: 16px;
          }
          @media (max-width: 680px) {
            font-size: 17px;
            top: 14px; left: 16px;
          }
        }
        &:hover{
          z-index: 3;
          .blogThumb{
            transform: scale(1.06);
          }
        }
      }
      .blogThumb{
        position: absolute;
        left: 40px; bottom: 40px; right: 40px; top: 80px;
        border-radius: 5px;
        transition: all .3s ease;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        @media (max-width: 1480px) {
          left: 24px; bottom: 24px; right: 24px; top: 70px;
        }
        @media (max-width: 860px) {
          left: 20px; bottom: 20px; right: 20px; top: 50px;
        }
        @media (max-width: 680px) {
          left: 12px; bottom: 16px; right: 12px; top: 44px;
        }
      }
      .blogImg{
        position: absolute;
        transition: all .3s ease;
        left: 0; bottom: 0; right: 0; top: 0;
        // height: 160px;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        &.blogimg-53, &.blogimg-54{
          top: 10px; bottom: 10px;
        }
        &.blogimg-48, &.blogimg-51{
          left: 10px; bottom: 10px; right: 10px; top: 10px;
        }
        &.blogimg-52{
          left: 18px; bottom: 18px; right: 18px; top: 18px;
        }
      }
      button{
        text-transform: uppercase;
        padding: 12px 24px 10px;
        display: none;
        &.signed{
          box-shadow: none;
          cursor: default;
          background-color: #ccc;
          color: #999;
          border-color: #ccc;
        }
        @media (max-width: 1460px) {
          padding: 10px 25px 8px;
        }
      }
      &.category{
        .blogImg{
          left: 20px; bottom: 20px; right: 20px; top: 120px;
          background-position: center;
          @media (max-width: 1160px) {
            top: 80px;
          }
          @media (max-width: 680px) {
            top: 50px;
          }
        }
        .itemIn{
          &:before{
            display: none;
          }
          h4{
            font-family: 'GolosUIWebBold', sans-serif;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: center;
          }
        }
      }
    }
  }
  &.notFound{
    text-align: center;
    padding: 0 0 40px;
    h4{
      margin: 0;
      font-size: 14px;
      color: #767676;
      font-weight: normal;
    }
    img{
      width: 84px;
      opacity: .56;
      margin: 0;

      margin: 16px 0 14px;
      width: 64px;
    }
  }
  &.loadingData{
    .theBlogSc{
      .blogItem{
        border: #fff 1px solid;
        box-sizing: border-box;
        .itemIn{
          transform: none !important;
        }
      }
    }
  }
}
</style>
